import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ExhibitAll from '../views/ExhibitAll.vue'
import CloudAlbum from '../views/CloudAlbum.vue'
import CloudForum from '../views/CloudForum.vue'
import CloudRelease from '../views/CloudRelease.vue'
import NewsList from '../views/NewsList.vue'
import NewsDetail from '../views/NewsDetail.vue'

Vue.use(VueRouter)

const SECTION_NAMES = new Set([
  'overview',
  'exhibit',
  'activity',
  'news',
  'floorplan',
  'register',
])

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/exhibit-all', name: 'ExhibitAll', component: ExhibitAll },
  { path: '/cloud-album', name: 'CloudAlbum', component: CloudAlbum },
  { path: '/cloud-forum', name: 'CloudForum', component: CloudForum },
  { path: '/cloud-release', name: 'CloudRelease', component: CloudRelease },
  { path: '/news', name: 'NewsList', component: NewsList },
  { path: '/news/:id', name: 'NewsDetail', component: NewsDetail, props: true },
  {
    // 兼容直接访问 /exhibit、/overview 等单段路径
    path: '/:section',
    redirect: to => {
      const sec = (to.params.section || '').toLowerCase();
      if (SECTION_NAMES.has(sec)) {
        return { path: '/', hash: '#' + sec };
      }
      return { path: '/' };
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ selector: to.hash })
        }, 500)
      })
    }
    return { x: 0, y: 0 }
  }
})

export default router
